import { useDispatch } from 'react-redux';
import { clearAccountNewsletters } from '@client/myAccount/newsletters/redux/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useClearNewslettersAction = (): typeof clearAccountNewsletters => {
  const dispatch = useDispatch();

  return bindActionCreators(clearAccountNewsletters, dispatch);
};
